export default "__VITE_ASSET__CxnNQGLf__"